module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.task.isDone()) ? _c('div', {
    staticClass: "task-item",
    class: _vm.taskItemClass() + " " + _vm.options.width
  }, [_c('div', {
    staticClass: "task-date"
  }, [_c('span', [_vm._v(_vm._s(_vm.task.dueOnDate()))]), (!_vm.task.undefined_time) ? _c('span', [_vm._v("- " + _vm._s(_vm.task.dueOnHour()))]) : _vm._e()]), (_vm.element_options.show_contact) ? _c('div', {
    staticClass: "task-contact clickable",
    on: {
      "click": function($event) {
        return _vm.toggleTaskBar(false)
      }
    }
  }, [_c('div', {
    staticClass: "spacer-15"
  }), _c('div', {
    staticClass: "contact-name overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.task.contact.full_name))]), _c('div', {
    staticClass: "contact-business"
  }, [_vm._v(_vm._s(_vm.task.contact.business.name))])]) : _c('div', {
    staticClass: "spacer-15"
  }), _c('div', {
    staticClass: "task-contact"
  }, [(_vm.task.created_by_type === 'FlowAction' && _vm.task.flow !== undefined) ? _c('div', {
    staticClass: "contact-flow"
  }, [_c('img', {
    attrs: {
      "src": require('../../assets/images/icons/flow-icon.svg'),
      "width": "9.5",
      "height": "9.5"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.task.flow.name))])]) : _vm._e()]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "interaction"
  }, [(!_vm.task.isMeetingTask()) ? _c('span', {
    staticClass: "sent"
  }, [_vm._v(_vm._s(_vm.total_delivery))]) : _vm._e(), (!_vm.task.isMeetingTask()) ? _c('span', {
    staticClass: "opened"
  }, [_vm._v(_vm._s(_vm.total_open))]) : _vm._e()]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "task-text"
  }, [_c('div', {
    staticClass: "task-description overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.task_description))]), _c('div', {
    staticClass: "task-info overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.task_info))])]), _c('div', {
    staticClass: "task-action-bar"
  }, [(!_vm.current_user.isMonitoringManager() && !_vm.task.isOzzyTask()) ? _c('div', {
    staticClass: "edit-task-action glyphicon glyphicon-pencil",
    on: {
      "click": _vm.editTask
    }
  }) : _vm._e(), (_vm.element_options.show_comment && _vm.task.comment) ? _c('div', {
    ref: "element_id",
    staticClass: "comment-task-action task-comment-icon",
    class: {
      'comment-icon-down': _vm.task.isEmailTask()
    },
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.tooltip_text,
      "data-placement": _vm.tooltip_placement
    }
  }) : _vm._e(), _c('div', {
    staticClass: "edit-task-action",
    class: _vm.iconClass(),
    on: {
      "click": _vm.emitOpenCompose
    }
  }), (_vm.show_second_call_button) ? _c('div', {
    staticClass: "phone-task-action clickable",
    on: {
      "click": function($event) {
        return _vm.toggleTaskBar(true)
      }
    }
  }, [_c('span', {
    staticClass: "dropdown-toggle glyphicon glyphicon-earphone"
  })]) : (_vm.show_call_button) ? _c('div', {
    staticClass: "phone-task-action clickable"
  }, [_c('span', {
    staticClass: "dropdown-toggle glyphicon glyphicon-earphone",
    attrs: {
      "data-toggle": "dropdown"
    }
  }), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [(_vm.task.contact.cellphone) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openDialer(_vm.task.contact.cellphone, "cellphone", _vm.task, true)
      }
    }
  }, [_vm._v("Ligar para celular " + _vm._s(_vm.normalizePhone(_vm.task.contact.cellphone)))])]) : _vm._e(), (_vm.task.contact.telephone) ? _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openDialer(_vm.task.contact.telephone, "telephone", _vm.task, true)
      }
    }
  }, [_vm._v("Ligar para telefone fixo " + _vm._s(_vm.normalizePhone(_vm.task.contact.telephone)))])]) : _vm._e(), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openDialer(null, "", _vm.task, true)
      }
    }
  }, [_vm._v("Ligar para outro número")])])])]) : _vm._e(), (!_vm.disable_toggle_done) ? _c('div', {
    staticClass: "done-menu glyphicon glyphicon-ok-circle clickable",
    on: {
      "click": _vm.toggleDone
    }
  }) : _vm._e()]), (_vm.task.assigned_to && !_vm.current_user.isSeller()) ? _c('div', {
    staticClass: "task-user"
  }, [_c('user-miniature', {
    attrs: {
      "user": _vm.task.assigned_to,
      "options": {
        first_name: true
      }
    }
  })], 1) : _vm._e(), _c('confirm', {
    attrs: {
      "id": _vm.confirmTaskId,
      "title": "Sua tarefa será finalizada",
      "message": "Deseja enviar o e-mail ou apenas concluir a tarefa?",
      "reject_text": "Apenas concluir",
      "confirm_text": "Concluir e enviar e-mail"
    },
    on: {
      "confirm-modal-confirm": _vm.sendEmailDoneTask,
      "confirm-modal-reject": _vm.doneTask
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30b27de6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/list_item.vue
// module id = 1070
// module chunks = 1